<span class="adelle-pe-31 font-weight-400 dark-gray">
    {{ pageHeadingTitle }}
    <ng-container *ngIf="pageHeadingSubTitle">
        <br />
        {{ pageHeadingSubTitle }}
    </ng-container>
</span>
